module.exports = __webpack_public_path__ + "img/logo.409cd10d.png";